import React from 'react';

import twMerge from 'utilities/src/twMerge';

import Icon from '../../../Icon';
import Image from '../../../Image';

/**
 * Widget Header Props
 */

export type WidgetHeaderProps = {
  title: string;
  images?: string[];
  className?: string;
};

/**
 * Widget Header Component
 */

export default function WidgetHeader({ title, images, className }: WidgetHeaderProps) {
  return (
    <div className={twMerge('flex items-center justify-between rounded-t-lg px-4 py-4 pt-3.5', className)}>
      <div className="flex items-center gap-0.5">
        {!!images?.length && (
          <div className="flex w-16 items-center group-[.is-open]:hidden">
            {images?.map((image, index) => (
              <div
                key={image}
                className="relative -mx-2 h-8 w-8 rounded-full"
                style={{ zIndex: images.length - index }}
              >
                <Image
                  src={image}
                  alt=""
                  width={80}
                  height={80}
                  className={twMerge('rounded-full border-2 border-current', className)}
                />
              </div>
            ))}
          </div>
        )}

        <h4 className="site-display-xs text-site-neutrals-900 font-medium">{title}</h4>
      </div>

      <Icon iconName="ExpandMore" size="IconSM" className="bg-site-neutrals-900 hidden group-[.is-open]:block" />
    </div>
  );
}
